import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignOut, Trophy, Key } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import PersonalTokensPanel from './PersonalTokensPanel';
import { useT } from '../i18n/I18nContext';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from './ui/dropdown-menu';

// Avatar menu in the top bar: what used to sit at the bottom of the sidebar.
export default function UserMenu() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const t = useT();
  const [tokensOpen, setTokensOpen] = useState(false);

  const initials = (user?.name || user?.email || '?')
    .split(/\s+/)
    .map((p) => p[0])
    .filter(Boolean)
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <button
            type="button"
            data-testid="user-menu-trigger"
            title={user?.name}
            style={user?.color ? { backgroundColor: user.color } : undefined}
            className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-[10px] font-semibold text-white outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-zinc-400 ${
              user?.color ? '' : 'bg-zinc-500'
            }`}
          >
            {initials}
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="z-[100] w-60 rounded-sm">
          <DropdownMenuLabel className="font-normal">
            <div className="text-sm font-semibold truncate" data-testid="user-menu-name">{user?.name}</div>
            <div className="text-[11px] text-zinc-500 truncate font-mono">{user?.email}</div>
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem data-testid="user-menu-stats" onSelect={() => nav('/stats')} className="rounded-sm text-sm gap-2">
            <Trophy size={14} /> {t('sidebar.stats')}
          </DropdownMenuItem>
          <DropdownMenuItem data-testid="personal-tokens-btn" onSelect={() => setTokensOpen(true)} className="rounded-sm text-sm gap-2">
            <Key size={14} /> {t('personalTokens.title')}
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem
            data-testid="logout-btn"
            onSelect={() => { logout(); nav('/login'); }}
            className="rounded-sm text-sm gap-2"
          >
            <SignOut size={14} /> {t('sidebar.signOut')}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <Dialog open={tokensOpen} onOpenChange={setTokensOpen}>
        <DialogContent className="rounded-sm sm:max-w-xl">
          <DialogHeader>
            <DialogTitle className="font-display font-black">{t('personalTokens.title')}</DialogTitle>
          </DialogHeader>
          {tokensOpen && <PersonalTokensPanel />}
        </DialogContent>
      </Dialog>
    </>
  );
}
